/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-23 12:45:46
 * @LastEditors Cong Yuan wso2848303@163.com
 * @LastEditTime 2025-02-19 14:19:06
 * @Description: 登录组件状态
 * @FilePath: /hsylc2021/src/components/login/loginState.js
 */
export default {
  LOGIN: 'LOGIN',
  REGIST: 'REGIST',
  COMPLETE_INFO: 'COMPLETE_INFO',
  FIND_PASSWORD: 'FIND_PASSWORD',
  WX_SERVICE: 'WX_SERVICE',
  SMS: 'SMS',
  SCHOOL: 'SCHOOL',
  WX: 'WX'
};
